'use strict';

import {Vector2} from "three";
import TWEEN from '../../../js/libs/tween.umd';
import {settingsData, threeJsVariables} from "../../settings";
import { enableOrbitControls, getCurrentCameraDistance } from '../controls/orbitControls';


export function animateCamera(
  currentCameraPosition,
  newCameraPosition,
  currentOrbitControlsTarget,
  newOrbitControlsTarget,
  currentDistance = getCurrentCameraDistance(),
  newDistance = threeJsVariables.orbitControls.minDistance,
  angle = threeJsVariables.orbitControls.getPolarAngle(),
  polarCameraCorrection = threeJsVariables.orbitControls.polarCameraCorrection,
  duration = 1000,
  easing = TWEEN.Easing.Sinusoidal.InOut,
  onStartCallback = ()=>{},
  onCompleteCallback = ()=>{})
{
    return new Promise(resolve => {

        const tween = new TWEEN.Tween({
            x1: currentCameraPosition.x, // current camera position x
            y1: currentCameraPosition.y, // current camera position y
            z1: currentCameraPosition.z, // current camera position z
            x2: currentOrbitControlsTarget.x, // current control center point x
            y2: currentOrbitControlsTarget.y, // current control center point y
            z2: currentOrbitControlsTarget.z, // current control center point z
            dist: currentDistance,
            angle: threeJsVariables.orbitControls.getPolarAngle(),
            cameraCorrection: threeJsVariables.orbitControls.polarCameraCorrection,
        });
        tween.to({
            x1: newCameraPosition.x, // a new camera position x
            y1: newCameraPosition.y, // a new camera position y
            z1: newCameraPosition.z, // a new camera position z
            x2: newOrbitControlsTarget.x, // a new control center point x
            y2: newOrbitControlsTarget.y, // a new control center point y
            z2: newOrbitControlsTarget.z, // new control center point z
            dist: newDistance,
            angle: angle,
            cameraCorrection: polarCameraCorrection
        },duration);
        tween.delay(0);
        tween.onStart(function() {
            settingsData.bombBlock = true;
            enableOrbitControls(false);
            onStartCallback();
        });
        tween.onUpdate(function(object){
            threeJsVariables.perspectiveCamera.position.x = object.x1;
            threeJsVariables.perspectiveCamera.position.y = object.y1;
            threeJsVariables.perspectiveCamera.position.z = object.z1;

            threeJsVariables.orbitControls.target.x = object.x2;
            threeJsVariables.orbitControls.target.y = object.y2;
            threeJsVariables.orbitControls.target.z = object.z2;
            threeJsVariables.orbitControls.minDistance = object.dist;
            threeJsVariables.orbitControls.minPolarAngle = object.angle;
            threeJsVariables.orbitControls.polarCameraCorrection = object.cameraCorrection;
        });
        tween.onComplete(function(){
            enableOrbitControls(true);
            settingsData.bombBlock = false;
            threeJsVariables.renderer.shadowMap.needsUpdate = true;
            onCompleteCallback();
            resolve();
        });
        tween.easing(easing);
        tween.start();
    });
}

export function animateCanvasResize (
  newSize,
  duration = 1000,
  easing = TWEEN.Easing.Sinusoidal.InOut,
  onStartCallback = ()=>{},
  onCompleteCallback = ()=>{}
) {
    const canvasCurrentSize = threeJsVariables.renderer.getSize(new Vector2());

    const tween = new TWEEN.Tween({
        sizeX: canvasCurrentSize.x,
        sizeY: canvasCurrentSize.y
    });

    tween.to({
        sizeX: newSize.x,
        sizeY: newSize.y
    },duration);

    tween.delay(0);

    tween.onUpdate(function(object) {
        threeJsVariables.perspectiveCamera.aspect = object.sizeX / object.sizeY;
        threeJsVariables.perspectiveCamera.updateProjectionMatrix();
        threeJsVariables.labelRenderer.setSize(object.sizeX, object.sizeY);
        threeJsVariables.renderer.setSize(object.sizeX,object.sizeY);
    });

    tween.onStart(function() {
        onStartCallback();
    });

    tween.onComplete(function() {
        onCompleteCallback();
    });

    tween.easing(easing);
    tween.start();

    return tween;
}

export function animateLightIntensity (
  light,
  newIntensity,
  duration = 1000,
  easing = TWEEN.Easing.Sinusoidal.InOut,
  onStartCallback = ()=>{},
  onCompleteCallback = ()=>{})
{
    const tween = new TWEEN.Tween({
        int: light.intensity,
    });

    tween.to({
        int: newIntensity
    },duration);

    tween.delay(0);

    tween.onUpdate(function(object) {
        light.intensity = object.int;
    });

    tween.onStart(function() {
        onStartCallback();
    });

    tween.onComplete(function() {
        onCompleteCallback();
    });

    tween.easing(easing);
    tween.start();

    return tween;
}

export function add_tween_animation(args, callback, on_complete_callback,onStartCallback) {
    const animation_obj = args.animation_obj;
    const start = args.start;
    const target = args.target;
    const duration = args.duration;
    const easing = args.easing;
    const delay = args.delay;
    settingsData.animation_name = 'animation_' + animation_obj.length;
    const animation = new TWEEN.Tween(start).to(target, duration);
    TWEEN.add(animation);
    animation.delay(delay);
    animation.onStart(()=>{
        // rendererAnimationPause(false);
        onStartCallback();
    });
    animation.onUpdate((e)=>{
        enableOrbitControls(false);
        callback(e);
    });
    animation.onComplete(()=>{
        enableOrbitControls(true);
        on_complete_callback();
    });
    animation.easing(easing);
    animation.start();
}

// function checkTweenAnimationIsDone () {
//     const isPlayed = tweenAnimationArray.filter(animation => animation._isPlaying === false);
//     if (isPlayed.length === 0){
//         enableOrbitControls(false);
//         return;
//     } else if (isPlayed.length === tweenAnimationArray.length -1){
//         enableOrbitControls(true);
//         tweenAnimationArray = [];
//     }
// }

// export class GsapAnimation {
//     constructor () {
//         this.animations = [];
//     }
//
//     add(animation){
//         this.animations.push(animation);
//     }
//
//     check(){
//         const isPlayed = this.animations.filter(animation => animation._time === 1);
//         if (isPlayed.length === this.animations.length){
//             rendererAnimationPause(true);
//         } else {
//             rendererAnimationPause(false);
//         }
//     }
// }